import * as React from "react";

export const useSmoothPropChanges = <T>(prop: T | null) => {
  const [smoothedValue, setSmootedValue] = React.useState<T | null>(prop);
  React.useEffect(() => {
    if (!!prop) setSmootedValue(prop);
  }, [prop]);
  return smoothedValue;
};
